<h1 matDialogTitle>Credit Invoiced Lines - {{data?.invoiceNumber}}</h1>

<mat-dialog-content>
  <div style="width: 100%">


    <mat-form-field style="width: 150px; margin-right: 16px">
      <mat-select [(ngModel)]="storeId" placeholder="Store" (selectionChange)="storeChanged($event)">
        <mat-option *ngFor="let store of stores" [value]="store.storeId">{{store.storeName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 200px; margin-right: 16px">
      <mat-label>Credit Note Number</mat-label>
      <input matInput type="text" [(ngModel)]="ledaineCreditNoteNumber" autocomplete="new-password">
    </mat-form-field>

    <mat-form-field style="width: 270px; margin-right: 16px">
      <mat-label>Approved By Manager Email</mat-label>
      <input matInput type="email" [(ngModel)]="approvedByEmail" autocomplete="new-password">
    </mat-form-field>

    <mat-form-field style="width: 280px;">
      <mat-label>Approved By Manager Password</mat-label>
      <input matInput type="password" [(ngModel)]="approvedByPwd" autocomplete="new-password">
    </mat-form-field>

    <kendo-grid *ngIf="lines" [kendoGridBinding]="lines" [scrollable]="true" [resizable]="true" [reorderable]="true"
      [sortable]="true">


      <kendo-grid-column [locked]="true" [width]="140" field="stockCode" title="Code">
      </kendo-grid-column>

      <!-- <kendo-grid-column [locked]="true" [width]="420" title="Description">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span class="ellipse">{{dataItem.lineDescription2 ? dataItem.lineDescription + ' - ' +
            dataItem.lineDescription2 :dataItem.lineDescription}}</span>
        </ng-template>
      </kendo-grid-column> -->

      <kendo-grid-column  [width]="170" title="Invoice Amount" class="td-number">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span style="text-align: right;" class="ellipse">{{dataItem.invoiceAmount | number:'1.2-2'}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="170" title="Refundable Amount" class="td-number">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span style="text-align: right;" class="ellipse">{{dataItem.refundableAmount | number:'1.2-2'}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="190" field="refundedAmount" class="td-number" title="Refund Amount">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <mat-form-field style="width: 100%;">
            <input matInput style="text-align: right;" type="number" [(ngModel)]="dataItem.refundedAmount" autocomplete="new-password">
          </mat-form-field>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="250" field="returnReasonCode" title="Refund Reason">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <mat-select *ngIf="dataItem.refundedAmount && dataItem.refundedAmount > 0" [(ngModel)]="dataItem.returnReasonCode" placeholder="">
            <mat-option *ngFor="let reason of reasons" [value]="reason.reasonCode">{{reason.description}}</mat-option>
          </mat-select>
        </ng-template>
      </kendo-grid-column>


    </kendo-grid>
  </div>
  <!-- <pre>{{selectedLines | json}}</pre>
  <pre>{{selectedLines.join(',')}}</pre> -->
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!valid" (click)="createCreditNote(false)">Create Credit Note</button>
</mat-dialog-actions>
